import { TextMediaTarget } from 'Shared/FrameModules/MediaLibrary/text_target';
import { Utils } from 'Shared/utils';

export function MultipleDocumentManager(container, options) {
   let docManager = this;
   let emptyTarget;
   options = options || {};

   let mediaTargets = [],
      createElements = Utils.createElements;
   mediaTargets = container.getElements('.mediaTarget').map(element => newTarget(element));

   mediaTargets.push(newTarget());

   this.browse = function () {
      emptyTarget.fireEvent('browse');
   };

   function newTarget(element, options) {
      options = options || {};

      let field = createElements({
         tag: 'input',
         type: 'hidden',
         name: 'intro[documents][]',
      });

      if (!element) {
         element = createElements({
            tag: 'li',
            c: 'add-new-document-container mediaTarget document-target customSetup listItem docBody hidden js-no-browse',
         });
         // Only disable when were creating a target from scratch.
         field.disable();
         element.inject(container, 'top');
      }

      element.grab(field);
      options.formField = field;
      options.accepts = 'guide_document';

      let target = new TextMediaTarget(element, options);
      target.addEvent('itemChanged', newItem => {
         // We don't want a bunch of empty targets laying around.
         if (newItem) {
            newItem.context.element.removeClass('hidden');
         } else {
            target.destroy();
            mediaTargets.erase(target);
         }

         target.getFormField().enable();
         addNewTargetIfNeeded();
         setModified(true);
      });

      emptyTarget = target;
      return target;
   }

   function addNewTargetIfNeeded() {
      let allFilled = mediaTargets.every(target => target.getMediaItem());

      if (allFilled) {
         mediaTargets.push(newTarget());
      }
   }

   docManager.modified = false;

   function setModified(isModified) {
      docManager.modified = isModified;
      docManager.fireEvent('modifiedChanged', [isModified]);
   }
}

Object.append(MultipleDocumentManager.prototype, Utils.EventsFunctions);
